import React, { Component } from 'react';
import { connect } from 'react-redux';
import { API_URL, IMAGE_URL } from "../../config/Config";
import axios from "axios/index";
import { Row, Col, Alert, Button, FormGroup, Label, Input, FormText } from "reactstrap";
import PageLoader from "../loader/PageLoader";
import { setUser } from "../../redux/actions/user";
import SaveLoader from "../../components/loader/SaveLoader";
import SweetAlert from 'sweetalert2-react';
import axiosRetry from 'axios-retry';
axiosRetry(axios, { retries: 3 });

class ChangeAvatar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            file: '',
            imagePreviewUrl: '',
            errors: {},
            hasAlert: false,
            loading1: true,
            isSave: false,
            type: 'success',
            title: 'Your information save successful.'
        };

    }

    handleChange(event) {
        event.preventDefault();
        let reader = new FileReader();
        let file = event.target.files[0];
        console.log('file');
        console.log(file);
        // console.log(reader.readAsDataURL(file));
        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result
            });
        };
        reader.readAsDataURL(file);

    }

    async handleSubmit(event) {
        event.preventDefault();
        const config = {
            headers: {
                'content-type': 'multipart/form-data'
            }
        };
        const formData = new FormData();
        formData.append('pic', this.state.file);
        this.setState({ loading1: false, hasAlert: false });

        try {
            let response = await axios.post(`${API_URL}user-upload-pic?api_token=${this.props.user.apiToken}`, formData, config);
            let user = await response.data.data;
            await this.props.setUser(user);
            this.setState({
                isSave: true,
                type: 'success',
                title: 'Your information save successful.'
            });

        } catch (e) {
            let apiError = await e.response;

            if (apiError === undefined) {
                console.log(e);
            } else {
                let data = await apiError.data;
                let apiErrorText = await data.data;
                this.setState({ apiErrorText });
            }
            this.setState({ hasAlert: true });
            this.setState({
                isSave: true,
                type: 'error',
                title: "An occurred during saving your info, try again."
            });


        }
        this.setState({ hasAlert: true, loading1: true });
    };

    render() {
        let { imagePreviewUrl } = this.state;
        let imagePreview = null;
        const user = this.props.user;

        if (imagePreviewUrl) {
            console.log('here 1');
            console.log(imagePreviewUrl);
            imagePreview = (<img src={imagePreviewUrl} alt={`${user.firstName} ${user.lastName}`} />);
        } else {
            console.log('here 2')
            imagePreview = (<img src={IMAGE_URL + this.props.user.pic} alt={`${user.firstName} ${user.lastName}`} />);
        }
        const { errors, loading } = this.state;


        return (
            <div className="pt-3">
                <Row>
                    <Col md="12">
                        {this.state.hasAlert ?
                            <Alert color="danger">
                                An occurred during saving your info, try again.
                            </Alert>
                            : ""}
                    </Col>
                </Row>
                {!loading ? <PageLoader type="bubbles" color="#4fbfa8" /> :
                    <form onSubmit={(e) => this.handleSubmit(e)} >
                        <Row>

                            <Col md="6" sm="12">
                                <div className="imgPreview">
                                    {imagePreview}
                                </div>
                            </Col>
                            <Col md="6" sm="12">
                                <FormGroup>
                                    <Label for="exampleFile">Your picture</Label>
                                    <Input
                                        type="file"
                                        className={errors["file"] ? "form-control is-invalid" : "form-control"}
                                        placeholder="تصویر کاربر"
                                        name="file"
                                        onChange={this.handleChange.bind(this)}
                                    />
                                    {errors["file"] ? <div className="invalid-feedback" >{errors["file"]}</div> : ""}
                                    <FormText color="muted">
                                        Allow file type: jpeg, png, gif less than 1024 kb.
                                    </FormText>
                                </FormGroup>
                                <div className="text-center mt-5">
                                    <Button color="info" block onClick={this.handleSubmit.bind(this)} className="mb-4 mt-4">
                                        <i className="fa fa-paper-plane-o white-text ml-1"></i> Upload
                                    </Button>
                                </div>

                            </Col>
                        </Row>
                    </form>}

                {!this.state.loading1 ? <SaveLoader type='spinningBubbles' color='#fff' height={document.body.clientHeight} /> : ""}
                <SweetAlert
                    show={this.state.isSave}
                    title={this.state.title}
                    type={this.state.type}
                    showConfirmButton={true}
                    onConfirm={() => this.setState({ isSave: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUser: user => {
            dispatch(setUser(user))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(ChangeAvatar);



// WEBPACK FOOTER //
// ./src/components/user/ChangeAvatar.js